import { STORAGE } from "project-config/constants";
import Cookie from "project-config/utils/cookie";
import { getDomain } from "project-config/utils/domain";

export function getTimeZone() {
  function getTimeNumber(time: number) {
    return Math.floor(Math.abs(time)).toString().padStart(2, "0");
  }

  const offset = new Date().getTimezoneOffset();
  return `${offset < 0 ? "+" : "-"}${getTimeNumber(
    offset / 60
  )}:${getTimeNumber(offset % 60)}`;
}

const CONST_HEADER = () => ({
  "Content-Type": "application/json",
  version: "1.0.0",
  signature: "rayvision2017",
  channel: 2,
  platform:
    sessionStorage.getItem(STORAGE.PLATFORM) ||
    Cookie.getCookie(STORAGE.PLATFORM) ||
    localStorage.getItem("platform") ||
    "0",
  sTraceId: "",
  userKey: sessionStorage.getItem(STORAGE.USER_KEY),
  languageFlag: Cookie.getCookie(STORAGE.LANGUAGE_FLAG) ?? getDomain(),
  timeZone: getTimeZone(),
});

export default CONST_HEADER;
